import { flow } from 'lodash';

import { NAME } from './checkout.constant';

import { selectModulesState } from '@giro-app/store/modules/modules.selector';

const selectStateKey = (state) => state[NAME];

export const selectState = flow(selectModulesState, selectStateKey);
